import React, { Component } from 'react';
import { Modal, Spin, Button } from 'antd';
import $ from '../../../common/AjaxRequest.js';
import API_URL from '../../../common/url.js';

class FloorPriceDetail extends Component {
    state = {
        params: {},
        record: {},
        visible: false,
        loading: false,
        talAuth: false, // 领域leader
    }

    show = (record, talAuth) => {
        this.setState({
            record,
            visible: true,
            talAuth,
        }, () => {
            this.queryEvaluateRecordBasePrice(record);
        });
    }

    hide = () => {
        this.setState({
            params: {},
            visible: false,
            loading: false,
        });
    }

    //获取建议底价数据
    queryEvaluateRecordBasePrice = (record) => {
        const { evaluateRecordOperateLogId } = record;
        const options = {
            method: "POST",
            url: API_URL.evaluate.queryBasePriceLog,
            data: { evaluateRecordOperateLogId },
            dataType: "json",
            doneResult: (res) => {
                const { data } = res;
                this.setState({
                    params: data ? data : {}
                })
            },
        };
        $.sendRequest(options);
    }


    render() {
        const { visible, loading, record, params, talAuth } = this.state;
        const { operateType} = record || {};
        const { serveFeeType = "BIND" } = params;
        const isBind = serveFeeType === "BIND" || serveFeeType === null;  //项目包含盲态服务
        const isNonBind = serveFeeType === "NON_BIND";  //项目包含非盲服务
        const isBindAndNonBind = serveFeeType === "NON_BIND,BIND";  //项目包含盲态服务和非盲服务
        if (isNonBind) {
            params.suggestEvaluateUnitPrice = params.nonBindSuggestEvaluateUnitPrice;
            params.suggestEvaluateTotalPrice = params.nonBindSuggestEvaluateTotalPrice;
            params.suggestInvestigationYearOutPut = params.nonBindSuggestInvestigationYearOutPut;
            params.suggestEvaluateUnitTaxPrice = params.nonBindSuggestEvaluateUnitTaxPrice;
            params.suggestEvaluateTotalTaxPrice = params.nonBindSuggestEvaluateTotalTaxPrice;
            params.suggestInvestigationYearOutPutTax = params.nonBindSuggestInvestigationYearOutPutTax;
            params.businessProposalUnitPrice = params.nonBindBusinessProposalUnitPrice;
            params.businessProposalTotalPrice = params.nonBindBusinessProposalTotalPrice;
            params.businessProposalInvestigationYearOutPut = params.nonBindBusinessProposalInvestigationYearOutPut;
        }
        const {
            whetherPushGpCalcuationValue,
            suggestEvaluateUnitPrice,
            suggestEvaluateTotalPrice,
            suggestInvestigationYearOutPut,
            nonBindSuggestEvaluateUnitPrice,
            nonBindSuggestEvaluateTotalPrice,
            nonBindSuggestInvestigationYearOutPut,
            rate,
            gpCalcuationValue,
            suggestEvaluateUnitTaxPrice,
            suggestEvaluateTotalTaxPrice,
            suggestInvestigationYearOutPutTax,
            nonBindSuggestEvaluateUnitTaxPrice,
            nonBindSuggestEvaluateTotalTaxPrice,
            nonBindSuggestInvestigationYearOutPutTax,
            remark,
            businessProposalUnitPrice,
            businessProposalTotalPrice,
            businessProposalInvestigationYearOutPut,
            nonBindBusinessProposalUnitPrice,
            nonBindBusinessProposalTotalPrice,
            nonBindBusinessProposalInvestigationYearOutPut,
        } = params;
        const { curRole }= sessionStorage;
        const showGpValue = (curRole == 'BD' || curRole == 'BA' || curRole == 'BDO' || curRole == 'BAL'|| curRole == 'BDM') ? !talAuth : true;
        
        return (
            <Modal
                title={'查看建议底价详情'}
                visible={visible}
                onCancel={this.hide}
                className="create-modal EditPersonModal"
                wrapClassName="vertical-center-modal"
                maskClosable={false}
                width={500}
                bodyStyle={{
                    minHeight: 450
                }}
                footer={<Button onClick={this.hide}>关闭</Button>}
            >
                <Spin spinning={loading}>
                    <div className="modal-content" style={{ padding: '0 20px' }}>
                        <ul className="modal-list">
                            {showGpValue &&
                                <li className="modal-item">
                                    <div className="item-left" style={{ width: '60%' }}>GP%:</div>
                                    <div className="item-right" style={{ width: '40%' }}>{gpCalcuationValue}%</div>
                                </li>
                            }
                            {/* <li className="modal-item">
                                <div className="item-left" style={{ width: '60%' }}>是否推送GP测算值:</div>
                                <div className="item-right" style={{ width: '40%' }}>{(whetherPushGpCalcuationValue || whetherPushGpCalcuationValue == 0) ? (whetherPushGpCalcuationValue == 0 ? '否' : '是') : ''}</div>
                            </li> */}
                            {(isBind || isNonBind) &&
                                <li className="modal-item">
                                    <div className="item-left" style={{ width: '60%' }}>建议单例价格金额(不含税)/人民币:</div>
                                    <div className="item-right" style={{ width: '40%' }}>{suggestEvaluateUnitPrice ? `${suggestEvaluateUnitPrice}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : ''}</div>
                                </li>
                            }
                            {(isBind || isNonBind) &&
                                <li className="modal-item">
                                    <div className="item-left" style={{ width: '60%' }}>建议总价金额(不含税)/人民币:</div>
                                    <div className="item-right" style={{ width: '40%' }}>{suggestEvaluateTotalPrice ? `${suggestEvaluateTotalPrice}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : ''}</div>
                                </li>
                            }
                            {(isBind || isNonBind) &&
                                <li className="modal-item">
                                    <div className="item-left" style={{ width: '60%' }}>建议项目年产出(不含税)/人民币:</div>
                                    <div className="item-right" style={{ width: '40%' }}>{suggestInvestigationYearOutPut ? `${suggestInvestigationYearOutPut}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : ''}</div>
                                </li>
                            }

                            {isBindAndNonBind &&
                                <li className="modal-item">
                                    <div className="item-left" style={{ width: '60%' }}>盲态服务建议单例价格金额(不含税)/人民币:</div>
                                    <div className="item-right" style={{ width: '40%' }}>{suggestEvaluateUnitPrice ? `${suggestEvaluateUnitPrice}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : ''}</div>
                                </li>
                            }
                            {isBindAndNonBind &&
                                <li className="modal-item">
                                    <div className="item-left" style={{ width: '60%' }}>盲态服务建议总价金额(不含税)/人民币:</div>
                                    <div className="item-right" style={{ width: '40%' }}>{suggestEvaluateTotalPrice ? `${suggestEvaluateTotalPrice}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : ''}</div>
                                </li>
                            }
                            {isBindAndNonBind &&
                                <li className="modal-item">
                                    <div className="item-left" style={{ width: '60%' }}>盲态服务建议项目年产出(不含税)/人民币:</div>
                                    <div className="item-right" style={{ width: '40%' }}>{suggestInvestigationYearOutPut ? `${suggestInvestigationYearOutPut}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : ''}</div>
                                </li>
                            }
                            {isBindAndNonBind &&
                                <li className="modal-item">
                                    <div className="item-left" style={{ width: '60%' }}>非盲服务建议单例价格金额(不含税)/人民币:</div>
                                    <div className="item-right" style={{ width: '40%' }}>{nonBindSuggestEvaluateUnitPrice ? `${nonBindSuggestEvaluateUnitPrice}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : ''}</div>
                                </li>
                            }
                            {isBindAndNonBind &&
                                <li className="modal-item">
                                    <div className="item-left" style={{ width: '60%' }}>非盲服务建议总价金额(不含税)/人民币:</div>
                                    <div className="item-right" style={{ width: '40%' }}>{nonBindSuggestEvaluateTotalPrice ? `${nonBindSuggestEvaluateTotalPrice}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : ''}</div>
                                </li>
                            }
                            {isBindAndNonBind &&
                                <li className="modal-item">
                                    <div className="item-left" style={{ width: '60%' }}>非盲服务建议项目年产出(不含税)/人民币:</div>
                                    <div className="item-right" style={{ width: '40%' }}>{nonBindSuggestInvestigationYearOutPut ? `${nonBindSuggestInvestigationYearOutPut}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : ''}</div>
                                </li>
                            }
                            <li className="modal-item">
                                <div className="item-left" style={{ width: '60%' }}>税率:</div>
                                <div className="item-right" style={{ width: '40%' }}>{rate}%</div>
                            </li>
                            {(isBind || isNonBind) &&
                                <li className="modal-item">
                                    <div className="item-left" style={{ width: '60%' }}>建议单例价格金额(含税)/人民币:</div>
                                    <div className="item-right" style={{ width: '40%' }}>{suggestEvaluateUnitTaxPrice ? `${suggestEvaluateUnitTaxPrice}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : ''}</div>
                                </li>
                            }
                            {(isBind || isNonBind) &&
                                <li className="modal-item">
                                    <div className="item-left" style={{ width: '60%' }}>建议总价金额(含税)/人民币:</div>
                                    <div className="item-right" style={{ width: '40%' }}>{suggestEvaluateTotalTaxPrice ? `${suggestEvaluateTotalTaxPrice}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : ''}</div>
                                </li>
                            }
                            {(isBind || isNonBind) &&
                                <li className="modal-item">
                                    <div className="item-left" style={{ width: '60%' }}>建议项目年产出(含税)/人民币:</div>
                                    <div className="item-right" style={{ width: '40%' }}>{suggestInvestigationYearOutPutTax ? `${suggestInvestigationYearOutPutTax}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : ''}</div>
                                </li>
                            }

                            {isBindAndNonBind &&
                                <li className="modal-item">
                                    <div className="item-left" style={{ width: '60%' }}>盲态服务建议单例价格金额(含税)/人民币:</div>
                                    <div className="item-right" style={{ width: '40%' }}>{suggestEvaluateUnitTaxPrice ? `${suggestEvaluateUnitTaxPrice}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : ''}</div>
                                </li>
                            }
                            {isBindAndNonBind &&
                                <li className="modal-item">
                                    <div className="item-left" style={{ width: '60%' }}>盲态服务建议总价金额(含税)/人民币:</div>
                                    <div className="item-right" style={{ width: '40%' }}>{suggestEvaluateTotalTaxPrice ? `${suggestEvaluateTotalTaxPrice}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : ''}</div>
                                </li>
                            }
                            {isBindAndNonBind &&
                                <li className="modal-item">
                                    <div className="item-left" style={{ width: '60%' }}>盲态服务建议项目年产出(含税)/人民币:</div>
                                    <div className="item-right" style={{ width: '40%' }}>{suggestInvestigationYearOutPutTax ? `${suggestInvestigationYearOutPutTax}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : ''}</div>
                                </li>
                            }
                            {isBindAndNonBind &&
                                <li className="modal-item">
                                    <div className="item-left" style={{ width: '60%' }}>非盲服务建议单例价格金额(含税)/人民币:</div>
                                    <div className="item-right" style={{ width: '40%' }}>{nonBindSuggestEvaluateUnitTaxPrice ? `${nonBindSuggestEvaluateUnitTaxPrice}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : ''}</div>
                                </li>
                            }
                            {isBindAndNonBind &&
                                <li className="modal-item">
                                    <div className="item-left" style={{ width: '60%' }}>非盲服务建议总价金额(含税)/人民币:</div>
                                    <div className="item-right" style={{ width: '40%' }}>{nonBindSuggestEvaluateTotalTaxPrice ? `${nonBindSuggestEvaluateTotalTaxPrice}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : ''}</div>
                                </li>
                            }
                            {isBindAndNonBind &&
                                <li className="modal-item">
                                    <div className="item-left" style={{ width: '60%' }}>非盲服务建议项目年产出(含税)/人民币:</div>
                                    <div className="item-right" style={{ width: '40%' }}>{nonBindSuggestInvestigationYearOutPutTax ? `${nonBindSuggestInvestigationYearOutPutTax}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : ''}</div>
                                </li>
                            }
                            <li className="modal-item">
                                <div className="item-left" style={{ width: '60%' }}>建议底价情况说明:</div>
                                <div className="item-right" style={{ width: '40%' }}>{remark}</div>
                            </li>
                            {
                                ((operateType == 'RE_REQUEST_CLINICAL' || operateType == 'BUSINESS_REAPPLY_CLINICAL') && (isBind || isNonBind)) &&
                                    <li className="modal-item">
                                        <div className="item-left" style={{ width: '60%' }}>商务建议单例价格金额(含税)/人民币:</div>
                                        <div className="item-right" style={{ width: '40%' }}>{businessProposalUnitPrice ? `${businessProposalUnitPrice}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : ''}</div>
                                    </li>
                            }
                            {
                                ((operateType == 'RE_REQUEST_CLINICAL' || operateType == 'BUSINESS_REAPPLY_CLINICAL') && (isBind || isNonBind)) &&
                                    <li className="modal-item">
                                        <div className="item-left" style={{ width: '60%' }}>商务建议总价金额(含税)/人民币:</div>
                                        <div className="item-right" style={{ width: '40%' }}>{businessProposalTotalPrice ? `${businessProposalTotalPrice}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : ''}</div>
                                    </li>
                            }
                            {
                                ((operateType == 'RE_REQUEST_CLINICAL' || operateType == 'BUSINESS_REAPPLY_CLINICAL') && (isBind || isNonBind)) &&
                                    <li className="modal-item">
                                        <div className="item-left" style={{ width: '60%' }}>商务建议项目年产出(含税)/人民币:</div>
                                        <div className="item-right" style={{ width: '40%' }}>{businessProposalInvestigationYearOutPut ? `${businessProposalInvestigationYearOutPut}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : ''}</div>
                                    </li>
                            }

                            {
                                ((operateType == 'RE_REQUEST_CLINICAL' || operateType == 'BUSINESS_REAPPLY_CLINICAL') && isBindAndNonBind) &&
                                    <li className="modal-item">
                                        <div className="item-left" style={{ width: '60%' }}>盲态服务商务建议单例价格金额(含税)/人民币:</div>
                                        <div className="item-right" style={{ width: '40%' }}>{businessProposalUnitPrice ? `${businessProposalUnitPrice}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : ''}</div>
                                    </li>
                            }
                            {
                                ((operateType == 'RE_REQUEST_CLINICAL' || operateType == 'BUSINESS_REAPPLY_CLINICAL') && isBindAndNonBind) &&
                                    <li className="modal-item">
                                        <div className="item-left" style={{ width: '60%' }}>盲态服务商务建议总价金额(含税)/人民币:</div>
                                        <div className="item-right" style={{ width: '40%' }}>{businessProposalTotalPrice ? `${businessProposalTotalPrice}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : ''}</div>
                                    </li>
                            }
                            {
                                ((operateType == 'RE_REQUEST_CLINICAL' || operateType == 'BUSINESS_REAPPLY_CLINICAL') && isBindAndNonBind) &&
                                    <li className="modal-item">
                                        <div className="item-left" style={{ width: '60%' }}>盲态服务商务建议项目年产出(含税)/人民币:</div>
                                        <div className="item-right" style={{ width: '40%' }}>{businessProposalInvestigationYearOutPut ? `${businessProposalInvestigationYearOutPut}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : ''}</div>
                                    </li>
                            }
                            {
                                ((operateType == 'RE_REQUEST_CLINICAL' || operateType == 'BUSINESS_REAPPLY_CLINICAL') && isBindAndNonBind) &&
                                    <li className="modal-item">
                                        <div className="item-left" style={{ width: '60%' }}>非盲服务商务建议单例价格金额(含税)/人民币:</div>
                                        <div className="item-right" style={{ width: '40%' }}>{nonBindBusinessProposalUnitPrice ? `${nonBindBusinessProposalUnitPrice}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : ''}</div>
                                    </li>
                            }
                            {
                                ((operateType == 'RE_REQUEST_CLINICAL' || operateType == 'BUSINESS_REAPPLY_CLINICAL') && isBindAndNonBind) &&
                                    <li className="modal-item">
                                        <div className="item-left" style={{ width: '60%' }}>非盲服务商务建议总价金额(含税)/人民币:</div>
                                        <div className="item-right" style={{ width: '40%' }}>{nonBindBusinessProposalTotalPrice ? `${nonBindBusinessProposalTotalPrice}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : ''}</div>
                                    </li>
                            }
                            {
                                ((operateType == 'RE_REQUEST_CLINICAL' || operateType == 'BUSINESS_REAPPLY_CLINICAL') && isBindAndNonBind) &&
                                    <li className="modal-item">
                                        <div className="item-left" style={{ width: '60%' }}>非盲服务商务建议项目年产出(含税)/人民币:</div>
                                        <div className="item-right" style={{ width: '40%' }}>{nonBindBusinessProposalInvestigationYearOutPut ? `${nonBindBusinessProposalInvestigationYearOutPut}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : ''}</div>
                                    </li>
                            }
                        </ul>
                    </div>
                </Spin>
            </Modal>
        )
    }
}

export default FloorPriceDetail;


// WEBPACK FOOTER //
// ./src/components/clinicalEvaluation/clinicalEvaluationRecord/FloorPriceDetail.js